export const resetUiPreferencesToDefaults = () => {
  // Enforce app defaults on logout: English + dark mode.
  try {
    localStorage.setItem("i18nextLng", "en");
    sessionStorage.setItem("i18nextLng", "en");
  } catch (_) {}

  try {
    localStorage.setItem("theme", "dark");
    sessionStorage.setItem("theme", "dark");
  } catch (_) {}

  if (typeof document !== "undefined") {
    document.documentElement.setAttribute("lang", "en");
    document.documentElement.setAttribute("dir", "ltr");
    document.documentElement.setAttribute("data-theme", "dark");
    document.body?.setAttribute("dir", "ltr");
  }
};
